// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LoginModal.module.css */
.LoginModal_modalOverlay__XlUj5 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .LoginModal_modalContainer__Ef4Mo {
    background-color: #121212;
    border-radius: 8px;
    width: 90%;
    max-width: 450px;
    box-shadow: 0 4px 20px rgba(255, 0, 0, 0.25);
    border: 1px solid #ff3333;
    position: relative;
    animation: LoginModal_fadeIn__evYbH 0.3s ease-in-out;
  }
  
  .LoginModal_closeButtonContainer__XI4Kc {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  
  .LoginModal_closeButton__Pn2Lc {
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s;
  }
  
  .LoginModal_closeButton__Pn2Lc:hover {
    background-color: rgba(255, 51, 51, 0.2);
  }
  
  .LoginModal_modalContent__2K8FL {
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .LoginModal_modalTitle__TCx3n {
    color: #ff3333;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 15px;
    text-align: center;
  }
  
  .LoginModal_modalMessage__iKFBh {
    color: #ffffff;
    font-size: 16px;
    margin-bottom: 25px;
    text-align: center;
  }
  
  .LoginModal_buttonContainer__IXyap {
    display: flex;
    gap: 15px;
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .LoginModal_loginButton__UlkAW {
    background-color: #ff3333;
    color: white;
    border: none;
    padding: 10px 25px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .LoginModal_loginButton__UlkAW:hover {
    background-color: #ff5252;
  }
  
  .LoginModal_cancelButton__qF3cc {
    background-color: transparent;
    color: #cccccc;
    border: 1px solid #cccccc;
    padding: 10px 25px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
  }
  
  .LoginModal_cancelButton__qF3cc:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
  }
  
  @keyframes LoginModal_fadeIn__evYbH {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* Media queries for responsiveness */
  @media (max-width: 480px) {
    .LoginModal_modalTitle__TCx3n {
      font-size: 20px;
    }
    
    .LoginModal_modalMessage__iKFBh {
      font-size: 14px;
    }
    
    .LoginModal_buttonContainer__IXyap {
      flex-direction: column;
      width: 100%;
    }
    
    .LoginModal_loginButton__UlkAW, .LoginModal_cancelButton__qF3cc {
      width: 100%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/common/Authenticated/LoginModal.module.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,4CAA4C;IAC5C,yBAAyB;IACzB,kBAAkB;IAClB,oDAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,0CAA0C;IAC1C,YAAY;EACd;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA,qCAAqC;EACrC;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,WAAW;IACb;;IAEA;MACE,WAAW;IACb;EACF","sourcesContent":["/* LoginModal.module.css */\n.modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .modalContainer {\n    background-color: #121212;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 450px;\n    box-shadow: 0 4px 20px rgba(255, 0, 0, 0.25);\n    border: 1px solid #ff3333;\n    position: relative;\n    animation: fadeIn 0.3s ease-in-out;\n  }\n  \n  .closeButtonContainer {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n  }\n  \n  .closeButton {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: background-color 0.2s;\n  }\n  \n  .closeButton:hover {\n    background-color: rgba(255, 51, 51, 0.2);\n  }\n  \n  .modalContent {\n    padding: 30px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .modalTitle {\n    color: #ff3333;\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 15px;\n    text-align: center;\n  }\n  \n  .modalMessage {\n    color: #ffffff;\n    font-size: 16px;\n    margin-bottom: 25px;\n    text-align: center;\n  }\n  \n  .buttonContainer {\n    display: flex;\n    gap: 15px;\n    width: 100%;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n  \n  .loginButton {\n    background-color: #ff3333;\n    color: white;\n    border: none;\n    padding: 10px 25px;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s;\n  }\n  \n  .loginButton:hover {\n    background-color: #ff5252;\n  }\n  \n  .cancelButton {\n    background-color: transparent;\n    color: #cccccc;\n    border: 1px solid #cccccc;\n    padding: 10px 25px;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n  }\n  \n  .cancelButton:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n    color: white;\n  }\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(-20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  /* Media queries for responsiveness */\n  @media (max-width: 480px) {\n    .modalTitle {\n      font-size: 20px;\n    }\n    \n    .modalMessage {\n      font-size: 14px;\n    }\n    \n    .buttonContainer {\n      flex-direction: column;\n      width: 100%;\n    }\n    \n    .loginButton, .cancelButton {\n      width: 100%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `LoginModal_modalOverlay__XlUj5`,
	"modalContainer": `LoginModal_modalContainer__Ef4Mo`,
	"fadeIn": `LoginModal_fadeIn__evYbH`,
	"closeButtonContainer": `LoginModal_closeButtonContainer__XI4Kc`,
	"closeButton": `LoginModal_closeButton__Pn2Lc`,
	"modalContent": `LoginModal_modalContent__2K8FL`,
	"modalTitle": `LoginModal_modalTitle__TCx3n`,
	"modalMessage": `LoginModal_modalMessage__iKFBh`,
	"buttonContainer": `LoginModal_buttonContainer__IXyap`,
	"loginButton": `LoginModal_loginButton__UlkAW`,
	"cancelButton": `LoginModal_cancelButton__qF3cc`
};
export default ___CSS_LOADER_EXPORT___;
